import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX, L_FLOW_HEX } from '../../../constants';
export const ABSORBER_CONFIG = {
    type: ERFElement.Absorber,
    icon: 'Absorber_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_upper_flow',
                    type: 'target',
                    name: 'Верхний поток питания',
                    position: Position.Left,
                    style: { top: 127, left: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_additional_flows',
                    type: 'target',
                    name: 'Дополнительные потоки питания',
                    position: Position.Left,
                    style: { top: 157, left: 8, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'target_material_lower_flow',
                    type: 'target',
                    name: 'Нижний поток питания',
                    position: Position.Left,
                    style: { top: 187, left: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_gas_flow',
                    type: 'source',
                    name: 'Газообразный продукт',
                    position: Position.Right,
                    style: { top: 28, right: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_additional_flows',
                    type: 'source',
                    name: 'Выходные потоки дополнительных боковых отборов',
                    position: Position.Right,
                    style: { top: 157, right: 8, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_material_liquid_flow',
                    type: 'source',
                    name: 'Жидкий продукт',
                    position: Position.Right,
                    style: { top: 286, right: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 306, left: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 306, right: 8, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFAbsorberNode.config.js.map